import React from "react"
import { Route, Redirect, useHistory, useLocation } from "react-router-dom"
import { useRecoilState } from "recoil"

import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"

export default function AuthenticatedRoute({ children, ...rest }) {
  const [isAuthenticating, setIsAuthenticating] = React.useState(true)
  const [association, setAssociation] = useRecoilState(currentAssociation)
  const [user] = useRecoilState(currentUser)
  const history = useHistory()
  const { pathname, search } = useLocation()

  React.useEffect(() => {
    if (!user.isLoggedIn) {
      return history.push(`/signin?redirect=${pathname}${search}`)
    }
    if (!user.email_verified) {
      return history.push(`/signup/confirm?redirect=${pathname}${search}`)
    }

    if (!association.id) {
      if (user && user.associations && user.associations.length === 1) {
        setAssociation({
          id: user.associations[0].association.id,
          name: user.associations[0].association.name,
        })
      } else if (!pathname.startsWith("/0/associations") && !pathname.startsWith("/signup")) {
        return history.push("/0/associations")
      }
    }
    setIsAuthenticating(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [association, user])

  return (
    !isAuthenticating && (
      <Route {...rest}>
        {user.isLoggedIn ? children : <Redirect to={`/signin?redirect=${pathname}${search}`} />}
      </Route>
    )
  )
}
